import CreatorSettingsPage from './CreatorSettingsPage'

export default CreatorSettingsPage
